import { render } from "./ViewRecord.vue?vue&type=template&id=d3c2540e&scoped=true"
import script from "./ViewRecord.vue?vue&type=script&lang=js"
export * from "./ViewRecord.vue?vue&type=script&lang=js"

import "./ViewRecord.vue?vue&type=style&index=0&id=d3c2540e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3c2540e"]])

export default __exports__